var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-textarea',{staticStyle:{"font-size":"0.8rem !important","min-width":"140px","height":"31px","padding":"0.3rem"},model:{value:(_vm.item[_vm.code]),callback:function ($$v) {_vm.$set(_vm.item, _vm.code, $$v)},expression:"item[code]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }